import { ComponentProps } from 'react'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type CardProperties = ComponentProps<'div'>

export const Card = ({
    className,
    ...properties
}: Readonly<CardProperties>): JSX.Element => {
    return (
        <div
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
